jQuery(function ($) {

	$( window ).scroll( function( e ) {
		resizeHeader($);
	});
	
});

function resizeHeader($) {
	var headerHeight = 0;
	var scrollTop = window.pageYOffset || 
	                document.documentElement.scrollTop || 
	                document.body.scrollTop || 
	                0;

	if ( scrollTop !== 0 ) {
		$('body').addClass('scrolled');
		headerHeight = jQuery('header').height();
		$('.site-header + *').css('margin-top', headerHeight );
		
	} else {
		$('body').removeClass('scrolled');
		$('.site-header + *').css('margin-top', 0 );
	}
}
